export const InsuranceStatus = {
  PROCESS : "PROCESS",
  CANCELLING : "CANCELLING",
  CANCELLED : "CANCELLED",
  COMPLETED : "COMPLETED"
};